import React, { useState, useEffect } from 'react';
import '../IntroPage.css';

const IntroPage = ({ onComplete }) => {
  const [isAnimating, setIsAnimating] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Play panther sound
    const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2467/2467-preview.mp3');
    audio.volume = 0.5;
    audio.play().catch(err => {
      if (process.env.NODE_ENV === 'development') console.log('Audio play failed:', err);
    });

    // Start fade out after 3 seconds
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 3000);

    // Complete intro after 4 seconds
    const completeTimer = setTimeout(() => {
      setIsAnimating(false);
      onComplete();
    }, 4000);

    return () => {
      clearTimeout(timer);
      clearTimeout(completeTimer);
      audio.pause();
    };
  }, [onComplete]);

  const handleSkip = () => {
    setFadeOut(true);
    setTimeout(() => {
      onComplete();
    }, 500);
  };

  if (!isAnimating) return null;

  return (
    <div className={`intro-page ${fadeOut ? 'fade-out' : ''}`}>
      <div className="intro-background">
        <div className="intro-overlay"></div>
        <div className="intro-particles">
          {Array.from({ length: 20 }, (_, i) => `particle-${i}`).map((id, i) => (
            <div key={id} className="particle" style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}></div>
          ))}
        </div>
      </div>
      
      <div className="intro-content">
        <div className="panther-logo-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_panthers-league/artifacts/h32tep3p_New%20Panthers%20Logo.jpg" 
            alt="Panthers Logo" 
            className="intro-logo"
          />
          <div className="logo-glow"></div>
        </div>
        
        <h1 className="intro-title">
          <span className="intro-word" style={{ animationDelay: '0.2s' }}>RANDALLSTOWN</span>
          <span className="intro-word" style={{ animationDelay: '0.6s' }}>PANTHERS</span>
        </h1>
        
        <div className="intro-tagline">
          <span style={{ animationDelay: '1s' }}>Building Champions</span>
        </div>
        
        <div className="prowl-line"></div>
      </div>

      <button className="skip-button" onClick={handleSkip}>
        Skip Intro
      </button>
    </div>
  );
};

export default IntroPage;